<div style="height: 100vh; width: 100%;">
    <div style="position: absolute; top: 35%; width:100%" fxLayout="column" fxLayoutAlign="center center" >
        <img src="./assets/images/sad.png" width="100px" style="max-width:350px">
        <br>
        <h2>Σφάλμα</h2>
        <p>Εχετε ξεπεράσει το όριο των προσπαθειών αποστολής One Time Password</p>
    </div>
</div>